import Annotation from "./Annotation";
import TextSection from "./TextSection";
import Project from "./Project";
import Text from "./Text";
import Resource from "./Resource";

export default {
  Annotation,
  TextSection,
  Project,
  Text,
  Resource
};
